import { colors } from "src/assets";
import React from "react";
import { View } from "react-native";
import { Icon } from "src/components";
import { useRequestUnreadCount } from "src/hooks";

export type OfferTabIconProps = {
  color: string;
};

export const OfferTabIcon: React.FC<OfferTabIconProps> = ({ color }) => {
  const [count] = useRequestUnreadCount();
  return (
    <View>
      <Icon name="send" color={color} size={24} />
      {count > 0 && (
        <View
          style={{
            position: "absolute",
            top: 0,
            right: -10,
            width: 8,
            height: 8,
            borderRadius: 4,
            backgroundColor: colors.orange,
          }}
        />
      )}
    </View>
  );
};
